import {
  ADD_VISITOR,
  ADD_VISITOR_FAILURE,
  ADD_VISITOR_SUCCESS,
  //
  DELETE_VISITOR,
  DELETE_VISITOR_FAILURE,
  DELETE_VISITOR_SUCCESS,
  //
  EDIT_VISITOR,
  EDIT_VISITOR_FAILURE,
  EDIT_VISITOR_SUCCESS,
  //
  FETCH_VISITORS,
  FETCH_VISITORS_FAILURE,
  FETCH_VISITORS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  CLOCK_VISITOR,
  CLOCK_VISITOR_SUCCESS,
  CLOCK_VISITOR_FAILURE,
  //
  SEARCH_VISITOR,
  SEARCH_VISITOR_SUCCESS,
  SEARCH_VISITOR_FAILURE,
  //
  SEARCH_RESIDENT,
  SEARCH_RESIDENT_SUCCESS,
  SEARCH_RESIDENT_FAILURE,
  //
  EXPORT_VISITORS,
  EXPORT_VISITORS_SUCCESS,
  EXPORT_VISITORS_FAILURE,
  //
  FETCH_ENTRIES,
  FETCH_ENTRIES_SUCCESS,
  FETCH_ENTRIES_FAILURE,
  //
  FIND_VISITOR,
  FIND_VISITOR_SUCCESS,
  FIND_VISITOR_FAILURE,
} from "./constants";

// List
export const fetchVisitors = (payload) => ({
  type: FETCH_VISITORS,
  payload,
});
export const fetchVisitorsSuccess = (payload) => ({
  type: FETCH_VISITORS_SUCCESS,
  payload,
});
export const fetchVisitorsFailure = (payload) => ({
  type: FETCH_VISITORS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addVisitor = (payload) => ({
  type: ADD_VISITOR,
  payload,
});
export const addVisitorSuccess = (payload) => ({
  type: ADD_VISITOR_SUCCESS,
  payload,
});
export const addVisitorFailure = (payload) => ({
  type: ADD_VISITOR_FAILURE,
  payload,
});
// EDIT
export const editVisitor = (payload) => ({
  type: EDIT_VISITOR,
  payload,
});
export const editVisitorSuccess = (payload) => ({
  type: EDIT_VISITOR_SUCCESS,
  payload,
});
export const editVisitorFailure = (payload) => ({
  type: EDIT_VISITOR_FAILURE,
  payload,
});
// DELETE
export const deleteVisitor = (payload, onDelete) => ({
  type: DELETE_VISITOR,
  payload,
  onDelete,
});
export const deleteVisitorSuccess = (payload) => ({
  type: DELETE_VISITOR_SUCCESS,
  payload,
});
export const deleteVisitorFailure = (payload) => ({
  type: DELETE_VISITOR_FAILURE,
  payload,
});

// Clock
export const clockVisitor = (payload, onSuccess) => ({
  type: CLOCK_VISITOR,
  payload,
  onSuccess,
});
export const clockVisitorSuccess = (payload) => ({
  type: CLOCK_VISITOR_SUCCESS,
  payload,
});
export const clockVisitorFailure = (payload) => ({
  type: CLOCK_VISITOR_FAILURE,
  payload,
});

// Search
export const searchVisitor = (payload) => ({
  type: SEARCH_VISITOR,
  payload,
});
export const searchVisitorSuccess = (payload) => ({
  type: SEARCH_VISITOR_SUCCESS,
  payload,
});
export const searchVisitorFailure = (payload) => ({
  type: SEARCH_VISITOR_FAILURE,
  payload,
});

// Resident
export const searchResident = (payload) => ({
  type: SEARCH_RESIDENT,
  payload,
});
export const searchResidentSuccess = (payload) => ({
  type: SEARCH_RESIDENT_SUCCESS,
  payload,
});
export const searchResidentFailure = (payload) => ({
  type: SEARCH_RESIDENT_FAILURE,
  payload,
});
// Export
export const exportVisitors = (payload) => ({
  type: EXPORT_VISITORS,
  payload,
});
export const exportVisitorsSuccess = (payload) => ({
  type: EXPORT_VISITORS_SUCCESS,
  payload,
});
export const exportVisitorsFailure = (payload) => ({
  type: EXPORT_VISITORS_FAILURE,
  payload,
});

export const fetchEntries = (payload) => ({
  type: FETCH_ENTRIES,
  payload,
});

export const fetchEntriesSuccess = (payload) => ({
  type: FETCH_ENTRIES_SUCCESS,
  payload,
});

export const fetchEntriesFailure = (payload) => ({
  type: FETCH_ENTRIES_FAILURE,
  payload,
});

export const findVisitor = (payload) => ({
  type: FIND_VISITOR,
  payload,
});
export const findVisitorSuccess = (payload) => ({
  type: FIND_VISITOR_SUCCESS,
  payload,
});
export const findVisitorFailure = (payload) => ({
  type: FIND_VISITOR_FAILURE,
  payload,
});
